import React from 'react'
import loader from "../images/loader.gif";
import Ajax from "../ajax/Ajax";
import {domain} from "../ajax/Ajax";

const Loading = () => (

    <div className="has-text-centered">
        <img className='loading' src={loader} alt="loading..."/>
    </div>

)

class Summary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dateRange:null,
            summaryLoaded:false,
            summary:{},
            fetching:false
        }


        this.fetchSummaryData = this.fetchSummaryData.bind(this)

    }

    async fetchSummaryData(){
        if (this.props.focus !== 'ware'){
            let fetchResults = await Ajax.fetchData(`${domain}/en/api/shop/v1/summary/?focus_id=${this.props.focusObj.token}`)
            if(fetchResults){
                if(fetchResults['status'] === 'success'){
                    this.setState({
                        summary:fetchResults['data'],
                        summaryLoaded:true
                    })
                }
            }
        }
    }


    async componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.focusObj.token !== prevProps.focusObj.token){
            this.fetchSummaryData()
        }

    }

    componentDidMount() {
        this.fetchSummaryData()
    }

    render() {
        return (
            <div>
                <div>
                    <div className="ml-2 mr-2">
                        <div className="is-size-4">
                            Today's Summary
                        </div>
                    </div>
                    <div className="columns">
                        <div className="column is-3">
                            <div className="card summary-box is-shadowless d-flex justify-content-center align-items-center">
                                {
                                    this.state.summaryLoaded || this.state.fetching?
                                        <div className="title">
                                            <p className="has-text-info">{this.state.summary.num_of_sales.toLocaleString()}</p>
                                            <p className="">SALES</p>
                                            <div>
                                                <span className="summary-bg zmdi zmdi-shopping-cart"></span>
                                            </div>
                                        </div>:
                                        <Loading/>
                                }


                            </div>
                        </div>
                        <div className="column is-3">
                            <div className="card summary-box is-shadowless d-flex justify-content-center align-items-center">
                                {
                                    this.state.summaryLoaded || this.state.fetching?
                                        <div className="title">
                                            <p className="has-text-info">{this.state.summary.num_of_items.toLocaleString()}</p>
                                            <p className="">ITEMS SOLD</p>
                                            <div>
                                                <span className="summary-bg zmdi zmdi-shopping-basket"></span>
                                            </div>
                                        </div>:
                                        <Loading/>
                                }

                            </div>
                        </div>
                        <div className="column is-3">
                            <div className="card summary-box is-shadowless d-flex justify-content-center align-items-center">
                                {
                                    this.state.summaryLoaded || this.state.fetching?
                                        <div className="title">
                                            <p className="has-text-info">{this.state.summary.currency} {this.state.summary.total_amount.toLocaleString()}</p>
                                            <p className="">REVENUE</p>
                                            <div>
                                                <span className="summary-bg zmdi zmdi-money"></span>
                                            </div>
                                        </div>:
                                        <Loading/>
                                }

                            </div>
                        </div>
                        <div className="column is-3">
                            <div className="card summary-box is-shadowless d-flex justify-content-center align-items-center">
                                {
                                    this.state.summaryLoaded || this.state.fetching?
                                        <div className="title">
                                            {
                                                this.state.summary.total_cash_out?
                                                    <p className="has-text-info">{this.state.summary.currency} {this.state.summary.total_cash_out.toLocaleString()}</p>
                                                    :
                                                    <p className="has-text-info">0</p>
                                            }

                                            <p className="">CASHED OUT</p>
                                            <div>
                                                <span className="summary-bg zmdi zmdi-money"></span>
                                            </div>
                                        </div>:
                                        <Loading/>
                                }

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}

export default Summary;